import { CancelableRequest } from '@fino/ng1-request/lib';
import '@fino/lib-injection';

export class ApiRequest extends CancelableRequest {
  constructor(...args) {
    super(...args);

    // Ensure that the mandatory services have been injected
    this.constructor.contractInjection(this, '$http');
    this.constructor.contractInjection(this, '$q');
    this.constructor.contractInjection(this, 'appConfig');
  }

  get api() {
    const { path, version } = this.appConfig.api;
    return `${path}/${version}`;
  }

  apiWithDivergentVersion(version) {
    return `${this.appConfig.api.path}/${version}`;
  }
}
